/* «Añadir» desde los resultados del buscador (oct-2026). Añade la variante y actualiza el icono y el
   carrito lateral con las mismas funciones del tema que usa la compra rápida (ProductForm / CartDrawer). */
(function () {
  'use strict';
  if (window.bwPsAdd) return;
  window.bwPsAdd = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-bw-ps-add]');
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-icon-bubble'];
    var drawerSection = drawer && drawer.closest('.shopify-section');
    if (drawerSection) sections.push(drawerSection.id.replace('shopify-section-', ''));

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.bwPsAdd), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'No se ha podido añadir.');
        return data;
      });
    }).then(function (data) {
      var PF = customElements.get('product-form');
      if (PF && PF.updateCartIcon && data.sections) PF.updateCartIcon(data);
      if (drawer && drawer.renderContents && data.sections) drawer.renderContents({ sections: data.sections }, true);
      btn.textContent = 'Añadido ✓';
    }).catch(function (e) {
      btn.textContent = 'Sin stock';
      btn.title = e.message;
    }).finally(function () {
      btn.classList.remove('is-loading');
    });
  }, true);
})();
